/**
 * @generated SignedSource<<639b3b4f20d25fee1db4dfef420fa7fa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ContentSubmissionsTable_ContentSubmissionFragment$data = {
  readonly " $fragmentSpreads": FragmentRefs<"LastUpdatedAtColumn_ContentSubmissionFragment" | "ProjectRewardsColumn_ContentSubmissionFragment" | "RootNodeTitleColumn_ContentSubmissionFragment" | "StartedAtColumn_ContentSubmissionFragment" | "StatusColumn_ContentSubmissionFragment">;
  readonly " $fragmentType": "ContentSubmissionsTable_ContentSubmissionFragment";
};
export type ContentSubmissionsTable_ContentSubmissionFragment$key = {
  readonly " $data"?: ContentSubmissionsTable_ContentSubmissionFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ContentSubmissionsTable_ContentSubmissionFragment">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "ContentSubmissionsTable_ContentSubmissionFragment"
};

(node as any).hash = "ebf2c490cf1973bbe4c9b42e7d10ec54";

export default node;
